import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import css from '@styled-system/css'

import LazyImage from '../../lazy-image';

export const Avatar = styled(LazyImage)`
  height: 45px;
  width: 45px;
  border-radius: 50%;
  object-fit: cover;
`

export const BottomWrapper = styled('div')`
  padding: 12px;
  display: flex;
  color: ${props => props.theme.colors.white};
  border-radius: 0 0 8px 8px;
  
  ${props => css({
    backgroundColor: props.backgroundColor || 'plasma.base'
  })}
`

export const Image = styled(LazyImage)`
  object-fit: cover;
  width: 238px;
  height: 238px;
`

const Link = styled('a')`
  text-decoration: none;
`

// Wraps the social card in an anchor tag if it is provided with a link URL.
export const LinkWrapper = ({ url, children }) =>  (url ? (
      <Link
        href={url}
        target={url ? '_blank' : null}
        rel={url ? 'noreferrer noopener' : null}>
        {children}
      </Link>
    ) : children
  )

LinkWrapper.propTypes = {
  url: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.elementType),
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired
}

LinkWrapper.defaultProps = {
  url: null
}


export const TextWrapper = styled('div')`
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const Wrapper = styled('div')`
  width: 238px;
  min-height: 300px;
  overflow: hidden;
  user-select: none;
`
